import {
  ADD_COUPON_PRODUCT_TO_CART_LIST,
  ADD_COUPON_PRODUCT_TO_CART_LIST_SUCCESS,
  ADD_COUPON_PRODUCT_TO_CART_LIST_FAILURE,

  FETCH_COUPON_CART_LIST,
  FETCH_COUPON_CART_LIST_SUCCESS,
  FETCH_COUPON_CART_LIST_FAILURE,

  REMOVE_COUPON_TO_CART_LIST,
  REMOVE_COUPON_TO_CART_LIST_SUCCESS,
  REMOVE_COUPON_TO_CART_LIST_FAILURE,

  SET_COUPON_DESCRIPTION_MODAL_VISIBLE,
  SET_SELECTED_COUPON,
  SET_CLIPPING_PRODUCT_ID,
} from "redux/constants/actionTypes";

let initialState = {
  couponCartList: [],
  addCouponToCartListLoading: false,
  addCouponToCartListLoadingError: "",

  couponCartListLoading:false,
  couponCartListLoadingError:"",

  removeCouponToCartListLoading:false,
  removeCouponToCartListError:false,

  couponDescriptionModalVisible: false,
  selectedCoupon: null,
  clippingProductId: false,
 };

const cartCoupon = (state = initialState, action) => {
  switch (action.type) {
    // Add to cart list

    case ADD_COUPON_PRODUCT_TO_CART_LIST:
      return {
        ...state,
        addCouponToCartListLoading: true,
      };
    case ADD_COUPON_PRODUCT_TO_CART_LIST_SUCCESS:
      return {
        ...state,
        addProductToCartListLoading: false,
        removeCouponToCartListLoading: false,
        addCouponToCartListLoading: false,
       
        couponCartList: [...state.couponCartList, action.payload],
      };
    case ADD_COUPON_PRODUCT_TO_CART_LIST_FAILURE:
      return {
        ...state,
        addCouponToCartListLoadingError: action.payload.error,
        removeCouponToCartListLoading: false,
        addCouponToCartListLoading: false,
      };
        // fetch cart list
  case FETCH_COUPON_CART_LIST:
      return {
        ...state,
        couponCartListLoading: true,
      };
    case FETCH_COUPON_CART_LIST_SUCCESS:
      return {
        ...state,
        couponCartListLoading: false,
        couponCartList: action.payload,
      };
    case FETCH_COUPON_CART_LIST_FAILURE:
      return {
        ...state,
        couponCartListLoadingError: action.payload.error,
      };


// remove cart list

  case REMOVE_COUPON_TO_CART_LIST:
    const cartCouponList = state.couponCartList;
    return {
      ...state,
      removeProductToCartListLoading: true,
      removeCouponToCartListLoading: true,
      couponCartList: cartCouponList.filter(
        (coupon) => coupon.offer_id !== action.payload
      ),
    };
  case REMOVE_COUPON_TO_CART_LIST_SUCCESS: {
    const updates = {}
    if (action.payload.offer_id) {
      updates.couponCartList = state.couponCartList.filter(
        (coupon) => coupon.offer_id !== action.payload.offer_id
      )
    }
    return {
      ...state,
      ...updates,
      removeCouponToCartListLoading: false,
      addCouponToCartListLoading: false,
    };
  }
  case REMOVE_COUPON_TO_CART_LIST_FAILURE:
    return {
      ...state,
      removeCouponToCartListError: action.payload.error,
      removeCouponToCartListLoading: false,
      addCouponToCartListLoading: false,
    };
  case SET_COUPON_DESCRIPTION_MODAL_VISIBLE: {
    const updates  = {}
    if (action.payload) {
      updates.selectedCoupon = null;
    }
    return {
      ...state,
      couponDescriptionModalVisible: action.payload,
    };
  }
  case SET_SELECTED_COUPON:
    return {
      ...state,
      selectedCoupon: action.payload,
    };
  case SET_CLIPPING_PRODUCT_ID:
    return {
      ...state,
      clippingProductId: action.payload,
    };
  default:
    return state;
  }
};

export default cartCoupon;
